import { request } from '@/utils/request'

// get
export const reqOrderRemind = () => request.get('delayHail/remind')



// WEBPACK FOOTER //
// ./src/api/global/index.js